module.exports = __webpack_public_path__ + "img/box_bg.c6f2285.png";